import { Component } from '@angular/core';

@Component({
  selector: 'app-email-message-section-wrapper',
  imports: [],
  template: `
    <div class="section">
      <div class="container">
        <h2 class="title text-center">Masz pytania?<br/>Skontaktuj się!</h2>
        <hr class="section-hr reveal fade-width"/>
        <div class="row">
          <div class="col-lg-2"></div>
          <div class="col-lg-8">
            <ng-content/>
          </div>
          <div class="col-lg-2"></div>
        </div>
      </div>
    </div>
  `
})
export class EmailMessageSectionWrapperComponent {

}
